/**
 * Component Product Details
 * 
 * @module product-details
 * @version 1.0.0
 * @extends HTMLElement
 */

class ProductDetails extends HTMLElement {
    /**
     * Product Details web component.
     * 
     * @constructor
     */
    constructor() {
        super();
        this.metafields = window.theme.productMetafields;
        this.initEvents();
    }

    /**
     * Init module
     */
    initEvents() {
        window.addEventListener('variant-change', this.onVariantChange.bind(this));
    }

    /**
     * Handle variant change event.
     */
    onVariantChange(event) {
        const productDescription = event.detail.product.description || '';

        this.metafields.productMetafields.variantMetafields.forEach(variantMetafields => {
            if (variantMetafields.variant_id == event.detail.variant.id) {
                const selectedColor = this.getColorOption(event.detail.variant.options);

                const trimmedProductDescription = this.getTrimmedOrFallback(variantMetafields.product_description, productDescription);
                const trimmedFeatures = this.getTrimmedOrFallback(variantMetafields.features, '');

                variantMetafields.product_description = this.replaceTextBasedOnColor(trimmedProductDescription, selectedColor);
                variantMetafields.features = this.replaceTextBasedOnColor(trimmedFeatures, selectedColor);

                const html = this.renderDetails(variantMetafields);
                if (html) {
                    this.innerHTML = `<div class="product-details__content">${html}</div>`;
                } else {
                    document.querySelector("[data-product-details]").classList.add("hidden");
                }
            }
        });
    }

    /**
     * Get the selected color from the variant options.
     */
    getColorOption(options) {
        const lowerCaseOptions = options.map(option => option.toLowerCase());
        return lowerCaseOptions.find(option => ['grey', 'gray', 'natural oak', 'white'].includes(option)) || null;
    }

    /**
     * Replace certain text based on the selected color.
     */
    replaceTextBasedOnColor(text, color) {
        if (!text || text === 'null') return text;

        // TODO: Switch it back after soon (april 2025)
        return text.replace('10-12 business days', '5 business days');
        // switch (color) {
        //     case 'grey':
        //     case 'gray':
        //     case 'natural oak':
        //         return text.replace('10-12 business days', '5 business days');
        //     case 'white':
        //     default:
        //         return text;
        // }
    }

    /**
     * Render product details HTML.
     */
    renderDetails(variantMetafields) {
        const productDescriptionHtml = this.renderMetafields(variantMetafields.product_description, this.metafields.productMetafields.product_description);
        const featuresHtml = this.renderMetafields(variantMetafields.features, this.metafields.productMetafields.features);
        return productDescriptionHtml + featuresHtml;
    }

    /**
     * Render individual metafields.
     */
    renderMetafields(variantValue, productValue) {
        const cleanedVariantValue = this.cleanValue(variantValue);
        const cleanedProductValue = this.cleanValue(productValue);
        return cleanedVariantValue ? `<div class="product-details__field">${cleanedVariantValue}</div>` :
               cleanedProductValue ? `<div class="product-details__field">${cleanedProductValue}</div>` : '';
    }

    /**
     * Clean and trim value or fallback.
     */
    getTrimmedOrFallback(value, fallback) {
        const cleanedValue = String(value || '').replace(/""/g, '').trim();
        return cleanedValue || fallback;
    }

    /**
     * Clean string value.
     */
    cleanValue(value) {
        if (!value || value === 'null') return '';
        return value.replace(/^./, "").replace(/.$/, '');
    }
}

customElements.define('product-details', ProductDetails);
